import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeroSliderService {
  activeSlide = 0;
  slides = [
    {
      images: [
        { path: 'images/heros/asterix.webp', type: 'image/webp' },
        { path: 'images/heros/asterix.png', type: 'image/png' }
      ],
      imageAlt: 'Discounts',
      tabIconClass: 'advantages',
      tabName: 'heroSlider.slide1Label',
      title: '',
      description: []
    },
    {
      images: [
        { path: 'images/heros/asterix_and_obelix.webp', type: 'image/webp' },
        { path: 'images/heros/asterix_and_obelix.png', type: 'image/png' }
      ],
      imageAlt: 'heroSlider.slide2Label',
      tabIconClass: 'storno',
      tabName: 'heroSlider.slide2Label',
      title: 'heroSlider.slide2title',
      description: []
    },
    {
      images: [{ path: 'images/heros/alpinToAlpyLogo.svg', type: 'image/svg+xml' }],
      imageAlt: 'heroSlider.slide3Label',
      tabIconClass: 'newAlpy',
      tabName: 'heroSlider.slide3Label',
      title: 'heroSlider.slide3title',
      description: []
    },
    {
      images: [
        { path: 'images/heros/asterix_village.webp', type: 'image/webp' },
        { path: 'images/heros/asterix_village.png', type: 'image/png' }
      ],
      imageAlt: 'heroSlider.slide4Label',
      tabIconClass: 'group',
      tabName: 'heroSlider.slide4Label',
      title: 'heroSlider.slide4title',
      description: []
    }
  ];
  readonly updatedActiveSlide = new EventEmitter<number>();

  updateActiveSlide(index: number) {
    this.activeSlide = index;
    this.updatedActiveSlide.emit(index);
  }

  next() {
    const page = this.activeSlide + 1;
    if (page >= this.slides.length) {
      this.updateActiveSlide(0);
    } else {
      this.updateActiveSlide(page);
    }
  }

  prev() {
    const page = this.activeSlide - 1;
    if (page < 0) {
      this.updateActiveSlide(this.slides.length - 1);
    } else {
      this.updateActiveSlide(page);
    }
  }
}
